import React from 'react'
import Icon from '../Icon'

const closeIcon = (close: () => void) => (
    <span className="close" onClick={close}>
        <Icon name="Close" className="icon" />
    </span>
)

export default closeIcon